export class SPCApi {
    async list(filters = null) {
        try {
            const response = await axios.get(`/adm/consultas-spc/list`, {
                params: filters,
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching spc:', error);
            throw error;
        }
    }

    async show(id) {
        try {
            const response = await axios.get(`/adm/consultas-spc/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching spc:', error);
            throw error;
        }
    }

    async store(data) {
        try {
            const response = await axios.post('/adm/consultas-spc', data);

            return response.data;
        } catch (error) {
            console.error('Error store spc:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/SPCApi.js